import {
  resolveProjectTrialAcronym,
  resolveSponsorProtocolIdForDisplay,
} from './projectIdentityFields';

/** Title page table field order — mirrors generateTitlePageContent in DocumentEditor (Word export). */
export const TITLE_PAGE_TABLE_FIELD_KEYS = [
  'sponsorConfidentialityStatement',
  'fullTitle',
  'trialAcronym',
  'sponsorProtocolIdentifier',
  'originalProtocol',
  'versionNumber',
  'versionDate',
  'amendmentIdentifier',
  'amendmentScope',
  'sponsorProductCodes',
  'investigationalProductNames',
  'trialPhase',
  'nctNumber',
  'shortTitle',
  'sponsorSignatory',
  'medicalExpertContact',
  'sponsorNameAddress',
  'coSponsorNameAddress',
  'localSponsorNameAddress',
  'deviceManufacturerNameAddress',
  'regulatoryIdentifiers',
  'sponsorApproval',
  'amendmentDetails',
];

/**
 * Trial acronym for title page only — omit when optional acronym was not set
 * (project.name may duplicate sponsor protocol ID).
 */
export function resolveTrialAcronymForTitlePage(project, adminInfo) {
  const acronym =
    resolveProjectTrialAcronym(project) || String(adminInfo?.trial_acronym || '').trim();
  if (!acronym) return '';
  const protocolId = resolveSponsorProtocolIdForDisplay(project, adminInfo);
  if (protocolId && acronym === protocolId) return '';
  return acronym;
}

export function shouldIncludeTitlePageTableRow(fieldKey, field) {
  if (!field || field.enabled === false) return false;
  const text = String(field.text || '').trim();
  if (!text) return false;
  if (fieldKey === 'trialAcronym') return Boolean(text);
  return true;
}
